<template>
  <div id="app" class="qualification-page">
    <!-- 页面头部 -->
    <header class="page-header">
      <div class="container">
        <h1>{{ $t('_cd._gszz') }}</h1>

        <p class="subtitle">{{ $t('_cd._wmyy') }}</p>
      </div>
    </header>

    <!-- 资质证书展示区域 -->
    <main class="main-content">
      <div class="container">
        <div class="qualifications-two-column">
          <!-- 左侧证书 -->
          <div class="certificate-item">
            <div class="certificate-image">
              <img src="../static/yyzz.png" />
            </div>
            <div class="certificate-info">
              <!-- <h3>科罗拉多州良好信誉证明</h3> -->
              <p>{{ $t('_cd._yyzz') }}</p>
              <!-- <div class="certificate-meta">
                <span class="issuer">科罗拉多州州务卿办公室</span>
                <span class="date">2023年10月30日</span>
              </div> -->
            </div>
          </div>

          <!-- 右侧证书 -->
          <div class="certificate-item">
            <div class="certificate-image">
              <img src="../static/yyzz2.png" />
            </div>
            <div class="certificate-info">
              <!-- <h3>商业经营许可证</h3> -->
              <p>{{ $t('_cd._yyzz2') }}</p>
              <!-- <div class="certificate-meta">
                <span class="issuer">科罗拉多州商业项目</span>
                <span class="date">2023年9月15日</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'QualificationPage'
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  color: #333;
  background-color: #f8f9fa;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 页面头部样式 */
.page-header {
  background: linear-gradient(135deg, #1a3a8f 0%, #2c5aa0 100%);
  color: white;
  padding: 60px 0;
  text-align: center;
  margin-bottom: 60px;
}

.page-header h1 {
  font-size: 2.5rem;
  margin-bottom: 15px;
  font-weight: 700;
}

.page-header .subtitle {
  font-size: 1.2rem;
  opacity: 0.9;
  max-width: 700px;
  margin: 0 auto;
}

/* 两列布局 */
.qualifications-two-column {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
  align-items: start;
  margin-bottom: 80px;
}

/* 证书项样式 */
.certificate-item {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.certificate-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
}

.certificate-image {
  /* height: 300px; */
  overflow: hidden;
}

.certificate-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.certificate-item:hover .certificate-image img {
  transform: scale(1.05);
}

.certificate-info {
  padding: 25px;
}

.certificate-info h3 {
  font-size: 1.4rem;
  margin-bottom: 12px;
  color: #1a3a8f;
  font-weight: 600;
}

.certificate-info p {
  color: #666;
  margin-bottom: 20px;
  line-height: 1.6;
  font-size: 1rem;
}

.certificate-meta {
  display: flex;
  justify-content: space-between;
  font-size: 0.9rem;
  color: #888;
  border-top: 1px solid #eee;
  padding-top: 15px;
}

.issuer {
  font-weight: 500;
  color: #555;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .qualifications-two-column {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .page-header {
    padding: 40px 0;
    margin-bottom: 40px;
  }

  .page-header h1 {
    font-size: 2rem;
  }

  .certificate-image {
    height: 250px;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 0 15px;
  }

  .page-header {
    padding: 30px 0;
  }

  .page-header h1 {
    font-size: 1.8rem;
  }

  .certificate-info {
    padding: 20px;
  }

  .certificate-info h3 {
    font-size: 1.3rem;
  }
}
</style>
